module.exports = __webpack_public_path__ + "img/detailsliftgate-only.ee6c26c2.svg";